import { render, staticRenderFns } from "./FormManage.vue?vue&type=template&id=2497a630&"
import script from "./FormManage.vue?vue&type=script&lang=js&"
export * from "./FormManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports